import { Component, Input, OnInit } from "@angular/core";
import { AlertController, PopoverController } from "@ionic/angular";
import { Project } from "src/app/models/Project";
import { Scene } from "src/app/models/Scene";
import { AuthorService } from "src/app/services/author.service";
import { DeepCopyService } from "src/app/services/deep-copy.service";
import { ModalService } from "src/app/services/modal.service";
import { ProjectsService } from "src/app/services/projects.service";
import { UnfocusElementService } from "src/app/services/unfocus-element.service";

@Component({
  selector: 'app-scene-menu-popover',
  templateUrl: './scene-menu-popover.component.html',
  styleUrls: ['./scene-menu-popover.component.scss'],
})
export class SceneMenuPopoverComponent implements OnInit {

  constructor(
    public unfocusService: UnfocusElementService,
    public alertController: AlertController,
    public popoverController: PopoverController,
    public authorService: AuthorService,
    public modalService: ModalService,
    public projectService: ProjectsService,
    public deepCopyService: DeepCopyService
  ) { }

  ngOnInit() {
  }

  async resetScene(event) {
    this.unfocusService.unfocus(event);
    const alert = await this.alertController.create({
      header: 'Reset Scene?',
      message: "Would you like to reset the current scene back to the last save?",
      cssClass: 'leave-alert quizard-alert quizard-leave-alert',
      buttons: [{
        text: 'No',
        cssClass: '',
        handler: () => {
        }
      }, {
        text: 'Yes',
        cssClass: '',
        handler: () => {
          this.authorService.resetScene(this.authorService.currentScene).then(result =>{
            this.popoverController.dismiss();
          });
        }
      }
      ]
    });
    await alert.present();

  }

  toggleSceneWireframe(scene) {
    if (scene.wireframe != true)
      scene.wireframe = true;
    else
      scene.wireframe = false;
  }

  copyScene(){
    this.authorService.copyScene(this.authorService.currentScene).then(result =>{
      this.popoverController.dismiss();
    });

  }

  deleteScene(){
    this.authorService.deleteScene(this.authorService.currentScene).then(result=>{
      this.popoverController.dismiss();
    })
  }

  
  launchScene(sceneId: number): Promise<void>{
    return new Promise<void>(async (resolve) => {
      await this.authorService.launchScene(sceneId);
      this.authorService.movingObject = null;
      this.authorService.selectedAsset = null;
      resolve();
    });
  }

  displaySettings(){    
    clearInterval(this.authorService.autosaveInterval);
    if(this.authorService.currentScene.opened){
      this.popoverController.dismiss();
      this.modalService.presentSceneSettings(this.authorService.currentScene, true, false).then(() => {
        this.authorService.startAutosave(this.authorService.autosaveInterval);
        this.launchScene(this.authorService.currentScene.sceneId);
      });
    }
  }

  toggleSceneAsProjectIcon(scene: Scene){
    let projectToUpdate: Project = this.deepCopyService.deepCopy(this.projectService.project);
    projectToUpdate.defaultSceneId = projectToUpdate.defaultSceneId == scene.sceneId ? 0 : scene.sceneId;
    this.projectService.updateDefaultSceneId(projectToUpdate);
    this.popoverController.dismiss().then(result => {
      this.projectService.project.defaultSceneId = projectToUpdate.defaultSceneId;
    });
  }

  displayOutcomeActions(){
    this.modalService.presentSceneOutcomeActions(this.authorService.currentScene, this.authorService.currentScene.projectId);
  }
}